<template>
  <div>
    <p class="text-center">素材历史作业时间点</p>
    <Divider style="margin: 10px 0;"/>

    <Timeline>
        <TimelineItem v-for="(item,index) in showRecords" :key="index">
          {{ item }}
        </TimelineItem>
        <TimelineItem v-if="readIndex<showRecords.length+1"><a @click="loadShowRecords">查看更多</a></TimelineItem>
    </Timeline>
  </div>
</template>

<script>
import { getImagePublishRecord } from '@/api/msp/search'

export default {
  data () {
    return {
      publishRecords: [],
      showRecords: [],
      readIndex: 0
    }
  },
  methods: {
    initPageData (selectImg) {
      getImagePublishRecord({ imageUrl: selectImg.filePath }).then(res => {
        this.publishRecords = res
        this.readIndex = 0
        this.loadShowRecords()
      })
    },
    loadShowRecords () {
      const showList = []
      const readCount = this.readIndex + 6

      for (let index = 0; index < readCount; index++) {
        if (index < this.publishRecords.length) {
          showList.push(this.publishRecords[index])
        }
      }

      this.showRecords = showList
      this.readIndex += 6
    }
  }
}
</script>
